var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vxe-card',[_c('vxe-button',{attrs:{"content":"button.return","icon":"vxe-icon-arrows-left","mode":"text","status":"primary"},on:{"click":_vm.back}})],1),_c('inventory-state-config',{ref:"configs",attrs:{"inventory-states":_vm.inventoryStates,"owners":_vm.owners,"warehouses":_vm.warehouses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }